import axios from "axios";
import env from "../env";

export const uploadMatterCD = (formData) => {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
        }
    };
    return axios.post(
        `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/certificateManager/cds`,
        formData,
        config
    );
};

export const fetchMatterCD = (productId, fwVersion) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
        params: {
            fwVersion
        }
    };
    return axios.get(
        `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/certificateManager/cds/products/${productId}`,
        config
    );
};


export const deleteMatterCD = (id, productId, fwVersion, tenantId = "panasonic") => {
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
            "X-Tenant-ID": tenantId,
        }, params: {
      productId,    // optional: helps backend pinpoint exact record
      fwVersion,    // optional: helps backend pinpoint exact record
    },
  };
    return axios.delete(
        `${env.GET_DEVICEMANAGEMENT_API_URL()}/simplifi/v1/certificateManager/cds/${id}`,
        config
    );
};
